import API from './api'
import {ExportDestination} from "components/forms/Form.types"
import {AxiosResponse} from "axios"

type Id = string | number

export const getExportDestinationsByClient = (environmentId: Id): Promise<AxiosResponse<ExportDestination[]>> => API.instanceData.get(`/exportDestination/byEnvironment/${environmentId}`)